import React from "react";
import Navbar from "../../components/Navbar/index.tsx";
import Pricing from "../../components/Pricing/index.tsx";

const PricingPage = () => {
  return (
    <div className="page">
      <Navbar />
      <div className="pt-16" />
      <Pricing />
    </div>
  );
};

export default PricingPage;
